import { useSelector } from "react-redux";
import { AppState } from "store";
//#region components
import { useCheckRelations } from "components/common";
import { PersonCompanyRelationType } from "models/enums/auth";
//#endregion
import useHasRevenueReportingTemplates from "serviceHooks/useHasRevenueReportingTemplates";

const useCashReconciliationPermissions = () => {
  const cashReconciliationEnabled = useSelector(
    (store: AppState) => store.auth.selectedCompany.cashReconciliationEnabledForCompany
  );

  const revenueReportingEnabledForCompany = useSelector(
    (store: AppState) => store.auth.selectedCompany.revenueReportingEnabledForCompany
  );

  const { getIsRevisor, hasRelations } = useCheckRelations();

  const hasCashReconciliationPermissions = () => {
    return hasRelations([PersonCompanyRelationType.CashReconciliation, PersonCompanyRelationType.Admin]);
  };

  const hasCashReconciliationRelation = !!hasCashReconciliationPermissions() || !!getIsRevisor();

  const { hasTemplates: hasRevenueReportingTemplates, loading: revenueReportingTemplatesLoading } =
    useHasRevenueReportingTemplates(!cashReconciliationEnabled && hasCashReconciliationRelation);

  const revenueReportingAvailableForCompany = !!cashReconciliationEnabled || hasRevenueReportingTemplates;

  const revenueReportingViewableForCompany = revenueReportingAvailableForCompany || revenueReportingEnabledForCompany;

  const canCreateCashReconciliations = () => {
    return revenueReportingAvailableForCompany && hasCashReconciliationPermissions();
  };

  const canViewCashReconciliations = () => {
    return revenueReportingViewableForCompany && (hasCashReconciliationPermissions() || getIsRevisor());
  };

  return {
    canCreateCashReconciliations: canCreateCashReconciliations,
    canViewCashReconciliations: canViewCashReconciliations,
    hasRevenueReportingTemplates: hasRevenueReportingTemplates,
    revenueReportingTemplatesLoading: revenueReportingTemplatesLoading,
    revenueReportingEnabledForCompany: revenueReportingEnabledForCompany,
  };
};

export default useCashReconciliationPermissions;
